/*----------------------------------------- DA FINIRE --------------------------- */

import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";
import VerificaToken from "../../components/VerificaToken";

function ModificaInfoPersonali() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const initialValues = {
    nome: user.nome,
    cognome: user.cognome,
    dataNascita: user.dataNascita,
    CAP: user.CAP,
    telefono: user.telefono,
    regione: user.regione,
    provincia: user.provincia,
    comune: user.comune,
    indirizzo: user.indirizzo,
    email: user.email,
  };

  const onSubmit = (data) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/modificaInfoPersonali`,
        data
      )
      .then(() => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setUser(res.data);
            history.push(`/account/info/${user.id}`);
          });
      });
  };

  const validationSchema = Yup.object().shape({
    nome: Yup.string("Devi passare una Stringa")
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    cognome: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    provincia: Yup.string()
      .min(2, "Valore non valido: Troppo corto!")
      .max(2, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    CAP: Yup.string().required("Per continuare devi compilare questo campo!"),
    dataNascita: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    telefono: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(10, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    regione: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    comune: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    indirizzo: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(25, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    email: Yup.string()
      .email("Inserisci una email valida")
      .required("Per continuare devi compilare questo campo!"),
  });

  return (
    <Container fluid>
      {/* SEZIONE BANNER */}
      <Container
        fluid
        id="banner_recovered"
        className="head-banner text-center text-white"
      >
        <Container>
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* SEZIONE FORM */}
      <Container className="form_registrazione">
        <h2 className="mt-3">Dati Anagrafici</h2>

        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row className="justify-content-md-center mt-3">
              <Col>
                <label className="mb-1 form_registrazione" for="nome">
                  Nome
                </label>
                <ErrorMessage name="nome" component="h6" />
                <Field
                  className="form-control input_registrazione"
                  name="nome"
                  placeholder="Inserisci Nome"
                />
                <label className="mb-1 mt-3 form_registrazione" for="provincia">
                  Provincia
                </label>
                <ErrorMessage name="provincia" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="provincia"
                  placeholder="Inserisci Provincia"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  for="dataDiNascita"
                >
                  Data di Nascita
                </label>
                <ErrorMessage name="dataNascita" component="h6" />
                <Field
                  type="date"
                  className="form-control input_registrazione"
                  name="dataNascita"
                  placeholder="Inserisci Data di Nascita"
                />
                <label className="mb-1 mt-3 form_registrazione" for="cap">
                  CAP
                </label>
                <ErrorMessage name="CAP" component="h6" />
                <Field
                  type="number"
                  className="form-control input_registrazione"
                  name="CAP"
                  placeholder="Inserisci CAP"
                />
                <label className="mb-1 mt-3 form_registrazione" for="telefono">
                  Telefono
                </label>
                <ErrorMessage name="telefono" component="h6" />
                <Field
                  type="number"
                  className="form-control input_registrazione"
                  name="telefono"
                  placeholder="Inserisci Telefono"
                />
              </Col>
              <Col>
                <label className="mb-1 form_registrazione">Cognome</label>
                <ErrorMessage name="cognome" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="cognome"
                  placeholder="Inserisci Cognome"
                />
                <label className="mb-1 mt-3 form_registrazione">Regione</label>
                <ErrorMessage name="regione" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="regione"
                  placeholder="Inserisci Regione"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  name="comune"
                  for="comune"
                >
                  Comune
                </label>
                <ErrorMessage name="comune" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="comune"
                  placeholder="Inserisci Comune"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  name="indirizzo"
                  for="indirizzo"
                >
                  Indirizzo
                </label>
                <ErrorMessage name="indirizzo" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="indirizzo"
                  placeholder="Inserisci Indirizzo"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  name="email"
                  for="email"
                >
                  Email
                </label>
                <ErrorMessage name="email" component="h6" />
                <Field
                  type="email"
                  className="form-control input_registrazione"
                  name="email"
                  placeholder="Inserisci Email"
                />
              </Col>
            </Row>
            <Button type="submit" variant="success" className="mt-3">
              Salva Modifiche
            </Button>
          </Form>
        </Formik>
      </Container>
    </Container>
  );
}

export default ModificaInfoPersonali;
